export enum CompanyStatus {
  Active = 'active',
  Declined = 'declined',
  UnderReview = 'under_review',
  RevocationStarted = 'revocation_started',
  QssPossible = 'qss_possible',
  QssExceeded = 'qss_exceeded',
  QssExpired = 'qss_expired',
  Revoked = 'revoked',
  Deactivated = 'deactivated',
  Adjust = 'adjust',
}
